import { useTranslation } from 'react-i18next';

export const useTqEnTimeframeExceededStatsLabels = (): Record<string, string> => {
  const { t } = useTranslation('tqen_timeframe_exceeded_stats_annual_report');

  const tqEnTimeframeExceededStatsLabels: Record<string, string> = {
    totalConsultationsWithLateResponses: t(
      'tqen_total_consultations_with_late_responses',
      'Total number of consultations with late responses'
    ),
    submittedWithin1To7DaysAfterDeadline: t(
      'tqen_total_consultations_with_late_responses_submitted_within_1_to_7_days_after_deadline',
      'Total number of consultations with late responses submitted within 1-7 days after the agreed deadline'
    ),
    percentageConsultationsWithLateResponsesSubmittedWithin1To7DaysAfterDeadline: t(
      'tqen_percentage_consultations_with_late_responses_submitted_within_1_to_7_days_after_deadline',
      'Percentage of consultations with late responses submitted within 1-7 days after the agreed deadline'
    ),
    submittedWithin8To14DaysAfterDeadline: t(
      'tqen_total_consultations_with_late_responses_submitted_within_8_to_14_days_after_deadline',
      'Total number of consultations with late responses submitted within 8-14 days after the agreed deadline'
    ),
    percentageConsultationsWithLateResponsesSubmittedWithin8To14DaysAfterDeadline: t(
      'tqen_percentage_consultations_with_late_responses_submitted_within_8_to_14_days_after_deadline',
      'Percentage of consultations with late responses submitted within 8-14 days after the agreed deadline'
    ),
    submittedWithin15To28DaysAfterDeadline: t(
      'tqen_total_consultations_with_late_responses_submitted_within_15_to_28_days_after_deadline',
      'Total number of consultations with late responses submitted within 15-28 days after the agreed deadline'
    ),
    percentageConsultationsWithLateResponsesSubmittedWithin15To28DaysAfterDeadline: t(
      'tqen_percentage_consultations_with_late_responses_submitted_within_15_to_28_days_after_deadline',
      'Percentage of consultations with late responses submitted within 15-28 days after the agreed deadline'
    ),
    submittedOver29DaysAfterDeadline: t(
      'tqen_total_consultations_with_late_responses_submitted_over_29_days_after_deadline',
      'Total number of consultations with late responses submitted over 29 days after the agreed deadline'
    ),
    percentageConsultationsWithLateResponsesSubmittedOver29DaysAfterDeadline: t(
      'tqen_percentage_consultations_with_late_responses_submitted_over_29_days_after_deadline',
      'Percentage of consultations with late responses submitted over 29 days after the agreed deadline'
    ),
  };

  return tqEnTimeframeExceededStatsLabels;
};
